import { Component, OnInit } from '@angular/core';
import { CampaignService} from '../../../services/campaign/campaign.service';
import { Campaign } from '../new-campaign/campaign';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { LoyaltyChart } from '../../../models/loyalty-chart-config.model';


@Component({
  selector: 'campaign-live-evaluation',
  templateUrl: './live-evaluation.component.html',
  providers: [ CampaignService ]
})
export class LiveEvaluationComponent implements OnInit {

  public campaign: Campaign;
  public remainingDays: number;
  public percentage: number;
  public visibleSerie: string;
  private colors;

  public charts = {
    emissionRedemption: { instance: null, options: null },
    budgetPerType: { instance: null, options: null }
  };

  constructor(
    private campaignService: CampaignService,
    private route: ActivatedRoute
  ) {
    this.colors = LoyaltyChart.colors;

    this.charts.budgetPerType.options = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false
      },
      title: {
        text: ''
      },
      tooltip: {
        valueSuffix: '%'
      },
      colors: this.colors,
      series: [{
        name: 'Budget per type',
        colorByPoint: true,
        data: []
      }],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      }
    };

    this.charts.emissionRedemption.options = {
      chart: { type: 'bar' },
      title: { text: '' },
      xAxis: {
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          align: 'high'
        },
        labels: {
          overflow: 'justify',
          formatter: function () {
            return this.value + '%';
          }
        }
      },
      tooltip: {
        valueSuffix: '%'
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y + '%';
            }
          }
        }
      },
      legend: {
        verticalAlign: 'top'
      },
      series: [
        { name: '', color: this.colors[0], data: [] },
        { name: '', color: this.colors[1], data: [] },
        { name: '', color: this.colors[0], data: [] },
        { name: '', color: this.colors[1], data: [] }
      ],
    };
  }

  ngOnInit()
  {
    const campaignName = this.route.snapshot.queryParams['campaign'];
    this.campaignService.getCampaign(campaignName).subscribe(res => {
      this.campaign = new Campaign(res);
      const endDate = (typeof res.redemptionEndDate !== 'undefined') ? this.campaign.redemptionEndDate : this.campaign.emissionEndDate;
      // this.remainingDays = Math.max(0, moment(endDate).diff(moment(), 'days'));
      this.loadCharts();
    });
  }

  chartInstance(chart: { instance, options }, chartInstance)
  {
    chart.instance = chartInstance;
  }

  updateSeries(serie: string)
  {
    this.visibleSerie = serie;

    switch(serie)
    {
      case 'emission':
        this.charts.emissionRedemption.instance.series[0].show();
        this.charts.emissionRedemption.instance.series[1].show();
        this.charts.emissionRedemption.instance.series[2].hide();
        this.charts.emissionRedemption.instance.series[3].hide();
        break;

      case 'redemption':
        this.charts.emissionRedemption.instance.series[0].hide();
        this.charts.emissionRedemption.instance.series[1].hide();
        this.charts.emissionRedemption.instance.series[2].show();
        this.charts.emissionRedemption.instance.series[3].show();
        break;
    }
  }

  loadCharts()
  {
    // subwave
    this.campaignService.getCampaignEmissionRedemptionData(this.campaign.name).subscribe(res => {
      this.charts.emissionRedemption.options.xAxis.categories = res.labels;
      this.charts.emissionRedemption.options.chart.height = 125 + res.labels.length * 50;

      // emission
      res.emmisionModel.forEach((data, i) => {
        this.charts.emissionRedemption.options.series[i].name = (data.label == 'Real') ? 'Actual' : data.label;
        this.charts.emissionRedemption.options.series[i].name += ' Emission';
        this.charts.emissionRedemption.options.series[i].data = data.values.map(v => Math.round(parseFloat(v) * 100));
      });

      // redemption
      res.redemptionModel.forEach((data, i) => {
        this.charts.emissionRedemption.options.series[i + 2].name = (data.label == 'Real') ? 'Actual' : data.label;
        this.charts.emissionRedemption.options.series[i + 2].name += ' Redemption';
        this.charts.emissionRedemption.options.series[i + 2].data = data.values.map(v => Math.round(parseFloat(v) * 100));
      });

      this.charts.emissionRedemption.instance.update(this.charts.emissionRedemption.options);
      this.updateSeries('emission');
    });

    // budget per type
    this.campaignService.getLiveEvaluationBudgetPerTypeData(this.campaign.name).subscribe(res => {
      res.forEach(data => {
        this.charts.budgetPerType.options.series[0].data.push({
          name: data.label,
          y: parseFloat(data.perc)
        });
      });
      this.charts.budgetPerType.instance.update(this.charts.budgetPerType.options);
    });

    // progress bar
    this.campaignService.getCampaignProgressData(this.campaign.name).subscribe(res => {
      this.percentage = res[1].value;
      this.remainingDays = res[0].value;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/live-evaluation/live-evaluation.component.ts